import React from "react";

interface HighlightedSectionProps {
  children: React.ReactNode;
  title?: string;
}

const HighlightedSection: React.FC<HighlightedSectionProps> = ({
  children,
  title,
}) => {
  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="bg-white rounded-2xl shadow-lg p-8">
          {title && (
            <h2 className="text-3xl font-bold text-center mb-12">
              {title}
            </h2>
          )}
          {children}
        </div>
      </div>
    </section>
  );
};

export default HighlightedSection;
